"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeGeodesic = void 0;
var tslib_1 = require("tslib");
// @ts-ignore
var geographiclib_1 = tslib_1.__importDefault(require("geographiclib"));
var unit_1 = require("../unit");
var geoidModel = geographiclib_1.default.Geodesic.WGS84;
/** Utility to provide geospatial operations. */
exports.IkeGeodesic = {
    /**
     * Calculate the absolute distance between two locations.
     *
     * @returns Distance in meters.
     */
    getDistance: function (source, target) {
        // @ts-ignore
        var result = geoidModel.Inverse(source.latitude, source.longitude, target.latitude, target.longitude);
        return Math.abs(result.s12);
    },
    /** Calculate the vector from one location to another. */
    getVector: function (source, target) {
        // @ts-ignore
        var result = geoidModel.Inverse(source.latitude, source.longitude, target.latitude, target.longitude);
        var distance = result.s12;
        var bearing = unit_1.IkeAngle.normalize(unit_1.IkeAngle.toRadians(result.azi1));
        var pitch = 0; // Not implemented until needed
        return { distance: distance, bearing: bearing, pitch: pitch };
    },
    /**
     * Move a location by a vector.
     *
     * @param source Original location.
     * @param bearing Bearing in radians.
     * @param distance Distance in meters.
     */
    projectLocation: function (source, bearing, distance) {
        var bearingDegrees = unit_1.IkeAngle.toDegrees(bearing);
        // @ts-ignore
        var result = geoidModel.Direct(source.latitude, source.longitude, bearingDegrees, distance);
        return {
            altitude: source.altitude,
            longitude: result.lon2,
            latitude: result.lat2
        };
    },
    /**
     * Find the center of a set of locations
     *
     * @param locations An array of locations to find the center of
     * @returns The center of the locations
     */
    findCenter: function (locations) {
        var e_1, _a;
        var sumLat = 0;
        var sumLng = 0;
        var subAlt = 0;
        try {
            for (var locations_1 = tslib_1.__values(locations), locations_1_1 = locations_1.next(); !locations_1_1.done; locations_1_1 = locations_1.next()) {
                var coordinate = locations_1_1.value;
                sumLat += coordinate.latitude;
                sumLng += coordinate.longitude;
                subAlt += coordinate.altitude;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (locations_1_1 && !locations_1_1.done && (_a = locations_1.return)) _a.call(locations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return {
            latitude: sumLat / locations.length,
            longitude: sumLng / locations.length,
            altitude: subAlt / locations.length
        };
    }
};
//# sourceMappingURL=geodesic.js.map